import { Box, IconButton, Typography } from "@mui/material";
import { useState } from "react";
import RefreshIcon from "@mui/icons-material/Refresh";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ChatSidebar from "../components/ChatSidebar";
import ChatWindow from "../components/ChatWindow";

const ModoEspiaoMobile = ({ contacts, endpointPrefix = "sdr", onSelectContact, currentTab, selectedContact }) => {
  const [refreshing, setRefreshing] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleRefresh = () => {
    setRefreshing(true);
    setRefreshKey((k) => k + 1);  // força re-montagem do ChatWindow
    setTimeout(() => setRefreshing(false), 600);
  };

  return (
    <Box sx={{ height: { xs: "100dvh", md: "100vh" }, width: "100%" }}>
      {/* Lista de contatos */}
      {!selectedContact ? (
        <ChatSidebar
          contacts={contacts}
          onSelectContact={onSelectContact}
          currentTab={currentTab}
          selectedContact={selectedContact}
        />
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: { xs: "100dvh", md: "100vh" },
            width: "100%",
            position: { xs: "fixed", md: "relative" },
            inset: { xs: 0, md: "auto" },
            bgcolor: "#fff",
            borderRadius: { xs: 0, md: "16px" },
            boxShadow: {
              xs: "none",
              md: "0 2px 12px rgba(0, 0, 0, 0.15)"
            },
            m: { xs: 0, md: 1 },
            overflow: "hidden",
            zIndex: { xs: 1300, md: "auto" },
          }}
        >
          {/* Topo com botão de voltar */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              px: 2,
              pt: { xs: "calc(env(safe-area-inset-top, 0px) + 12px)", md: 2 },
              pb: { xs: 1.5, md: 2 },
              bgcolor: "#00A884", // Verde WhatsApp
              gap: 1,
              flexShrink: 0, // Impede que o cabeçalho encolha
              justifyContent: "space-between"
            }}
          >
            <IconButton
              onClick={() => onSelectContact(null)}
              sx={{ color: "#fff" }}
            >
              <ArrowBackIcon />
            </IconButton>
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", fontSize: "1rem", color: "#fff" }}
            >
              {selectedContact.nome || selectedContact.whatsAppId}
            </Typography>

            <IconButton
              onClick={handleRefresh}
              disabled={refreshing}
              sx={{
                color: "#fff",
                "&:hover": {
                  bgcolor: "rgba(255, 255, 255, 0.1)",
                },
              }}
            >
              <RefreshIcon
                sx={{
                  animation: refreshing ? "spin 1s linear infinite" : "none",
                  "@keyframes spin": {
                    "0%": {
                      transform: "rotate(0deg)",
                    },
                    "100%": {
                      transform: "rotate(360deg)",
                    },
                  },
                }}
              />
            </IconButton>
          </Box>

          {/* Janela de conversa - Adicionando flex-grow e overflow */}
          <Box sx={{
            flexGrow: 1,
            overflow: "auto", // Habilita o scroll
            display: "flex",
            flexDirection: "column",
            height: { xs: "calc(100dvh - 72px)", md: "calc(100vh - 64px)" },
            width: "100%"
          }}>
            <ChatWindow
              key={`${selectedContact?.whatsAppId || selectedContact?.nome || ""}-${refreshKey}`}
              selectedContact={selectedContact}
              endpointPrefix={endpointPrefix}
              sx={{ flexGrow: 1, width: "100%", alignSelf: "stretch" }} // <-- adicione estes
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default ModoEspiaoMobile;

